'use client';

import ZoomInIconSvg from '@/assets/svgs/text-editor/zoom-in.svg';
import { MediaItem } from '@/containers/MediaManager/types';
import classNames from 'classnames';

interface MediaItemViewProps {
  className?: string;
  data: MediaItem;
  onZoomMediaClicked: () => void;
  onSelected: () => void;
}

const MediaItemView = ({
  className,
  data,
  onZoomMediaClicked,
  onSelected,
}: MediaItemViewProps) => {
  const isPending = data.status === 'PENDING';
  const isActive = data.status === 'ACTIVE';

  return (
    <div
      className={classNames(
        'group dark:bg-base-200 relative flex w-full cursor-pointer flex-col rounded-lg border border-gray-200 bg-white transition-all duration-200 dark:border-gray-700',
        {
          'hover:border-gray-300 hover:shadow-md dark:hover:border-gray-500': isActive,
          'opacity-75': isPending,
          'cursor-not-allowed': isPending,
        },
        className
      )}
      tabIndex={0}
      onClick={() => {
        if (isActive) {
          onSelected();
        }
      }}>
      {/* Thumbnail Section */}
      <div className="dark:bg-base-300 relative aspect-square w-full overflow-hidden rounded-md rounded-b-none bg-gray-100">
        {/* Thumbnail Image */}
        {data.thumbnail_url && isActive ? (
          <>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img
              src={data.thumbnail_url}
              alt={data.title}
              className="h-full w-full object-cover transition-transform duration-200 group-hover:scale-105"
            />

            {/* Zoom Button Overlay */}
            <button
              className="btn btn-square btn-sm border-black-500/70 bg-black-500/70 absolute top-2 right-2 flex items-center justify-center rounded-full opacity-0 transition-opacity group-hover:opacity-100"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onZoomMediaClicked();
              }}>
              <ZoomInIconSvg className="h-4 w-4 text-white" />
            </button>
          </>
        ) : (
          /* Pending/Loading State */
          <div className="dark:bg-base-300 flex h-full w-full items-center justify-center bg-gray-200">
            <div className="text-center">
              <span className="loading loading-spinner loading-md text-gray-400"></span>
              <div className="mt-2 text-xs text-gray-500 dark:text-gray-400">
                Processing...
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Information Section */}
      <div className="flex flex-col px-3 py-2">
        {/* Title */}
        <p
          className="truncate text-xs font-medium text-gray-900 group-hover:text-gray-700 dark:text-gray-200 dark:group-hover:text-white"
          title={data.title}>
          {data.title}
        </p>
      </div>
    </div>
  );
};

export default MediaItemView;
